module.exports = __webpack_public_path__ + "img/MyPCP-Enrollment-Slider-1.29024530.svg";